import { $, _ } from "js/vendor";
import { getStaticUrl } from "js/config";

const templates = {};

let reqContext = require.context("raw-loader!../../../static/templates/", false, /.tpl.html$/);
reqContext.keys().map(
    tpl => {
        let templateName = tpl.split("/").pop().split(".").shift();
        templates[templateName] = reqContext(tpl);
    });

export function getTemplate(template) {
    if (!templates[template]) {
        const url = getStaticUrl(`/templates/${template}.tpl.html`);
        $.ajax({
            url: url,
            async: false,
            success: function(results) {
                templates[template] = results.replace(/target-src="([^"]+)"/g, "src='$1'");
            }
        });
    }
    return templates[template];
}

export function template(template) {
    return _.template(getTemplate(template));
}
